import "../common/loading-animation.js";
import { dataToObject, apiHost } from "./utils.js";
import axios from "axios";
import { html } from "lit";
import { when } from "lit/directives/when.js";
import isEqual from "lodash-es/isEqual.js";
class QuoteController {
  constructor(host, onChange) {
    this.status = 0;
    (this.host = host).addController(this);
    this.onChange = onChange;
  }
  async hostUpdate() {
    const datasetObj = dataToObject(this.host.dataset);
    if (!isEqual(this.host.policyAttributes, {}) && this.host.clientId !== void 0 && (!isEqual(this.host.policyAttributes, this.policyAttributes) || !isEqual(this.host.customer, this.customer) || !isEqual(datasetObj, this.metadata))) {
      this.metadata = datasetObj;
      await this.loadQuote();
    }
  }
  async loadQuote() {
    var _a, _b, _c;
    this.status = 0;
    this.policyAttributes = this.host.policyAttributes;
    this.customer = this.host.customer;
    let requestBody = {
      customer: this.customer,
      policy_attributes: this.policyAttributes
    };
    if (this.host.quoteId) {
      requestBody["quote_id"] = this.host.quoteId;
    }
    if (this.host.offerId) {
      requestBody["offer_id"] = this.host.offerId;
    }
    if (this.metadata) {
      requestBody["metadata"] = this.metadata;
    }
    try {
      const response = await axios.post(`${apiHost}/v1/quote/${this.host.product}`, requestBody, {
        headers: {
          "Content-Type": "application/json",
          "x-api-client-id": this.host.clientId,
          "x-api-source": "Web Component",
          "x-api-web-component-version": "4.14.0"
        }
      });
      this.status = 1;
      this.value = response.data;
      this.host.quoteId = response.data.quote_id;
      if (response.data.offer_id) {
        this.host.offerId = response.data.offer_id;
      }
      this.onChange();
    } catch (e) {
      this.status = 2;
      const responseError = e;
      const data = (_a = responseError.response) == null ? void 0 : _a.data;
      const status = (_b = responseError.response) == null ? void 0 : _b.status;
      if (status === 422 || status === 404) {
        this.host.unsetOfferId();
        this.host.unsetQuoteId();
        await this.loadQuote();
      } else {
        if (!(data == null ? void 0 : data._embedded)) {
          this.error = new Error(data == null ? void 0 : data.message, { cause: data == null ? void 0 : data.error });
        } else {
          const cause = (_c = data._embedded.errors[0]) == null ? void 0 : _c.message;
          this.error = new Error(data == null ? void 0 : data.message, { cause });
        }
        this.host.dispatchEvent(new CustomEvent("quote-error", {
          detail: this.error,
          bubbles: true,
          composed: true
        }));
        if (this.host.debug) {
          console.debug("Failed to retrieve quote", this.error);
        }
      }
    }
    this.host.requestUpdate();
  }
  render(renderer) {
    return html`
      <div id="offer-wrapper">
        ${when(this.status === 0 && this.value != void 0, () => html`
          <loading-animation></loading-animation>
        `)}
        ${this._pendingRenderWrapper(renderer)}
      </div>
    `;
  }
  _pendingRenderWrapper(renderer) {
    var _a, _b, _c;
    if (this.status === 2) {
      return (_a = renderer.error) == null ? void 0 : _a.call(renderer, this.error);
    } else if (this.status === 0 && this.value == void 0) {
      return (_b = renderer.pending) == null ? void 0 : _b.call(renderer);
    } else {
      return (_c = renderer.complete) == null ? void 0 : _c.call(renderer, this.value);
    }
  }
}
export {
  QuoteController
};
